module.exports = __webpack_public_path__ + "media/18.f7988df4.mp3";